import React from 'react';
import moment from 'moment';
import { CircularProgress } from '@material-ui/core';
import CalendarSchedules from './calendarSchedules';
import './calendar.css';

const Calendar = ({ week, loading, staffSchedules, printTable, allRooms, allStaff }) => {
	return (
		<div className={printTable}>
			<table className="table-container bg-white">
				<thead>
					<tr>
						<th className="table-side-header">Active Staff</th>
						{week.map((day, key) => {
							return (
								<th key={key} style={{ textAlign: 'center' }}>
									<div
										className={`week-days ${
											moment(day).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') ? 'current-date' : ''
										}`}
									>
										<span className="day">{moment(day).format('ddd')}</span>
										<span className="date">{moment(day).format('DD')}</span>
									</div>
								</th>
							);
						})}
					</tr>
				</thead>
				{staffSchedules[0] ? (
					<tbody>
						{staffSchedules.map((teacher) => {
							return (
								<CalendarSchedules
									key={teacher.id}
									rooms={allRooms}
									schedule={teacher.schedule}
									staff={allStaff}
									teacher={teacher}
									week={week}
								/>
							);
						})}
					</tbody>
				) : null}
			</table>
			{loading ? (
				<div className="loading-spinner">
					<CircularProgress size={35} />
				</div>
			) : null}
			{!loading && !staffSchedules[0] ? (
				<div className="no-schedules">
					<p>No Schedules</p>
				</div>
			) : null}
		</div>
	);
};

export default Calendar;
